module.exports = __webpack_public_path__ + "img/triangle-danger-20x20.f5357c2b.svg";